import { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import axios from "axios";
import { Calendar } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = '/api';

export default function TodayInHistory() {
  const [historyData, setHistoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(`${API}/history/today`);
        setHistoryData(response.data);
      } catch (error) {
        console.error("Tarih bilgisi yüklenemedi:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, []);

  if (loading) {
    return (
      <Card className="p-4 bg-gradient-to-br from-red-500/10 to-red-600/5 border-red-500/20 animate-pulse">
        <div className="h-24"></div>
      </Card>
    );
  }

  if (!historyData) return null;

  const { national_day, historical_events } = historyData;
  const displayEvent = national_day || (historical_events && historical_events[0]);

  if (!displayEvent) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-red-500/10 to-red-600/5 border-red-500/20 hover:border-red-500/40 transition-all duration-300">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center flex-shrink-0">
          <Calendar className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-bold text-white truncate">Bugün Tarihte</h3>
          {displayEvent.emoji && (
            <span className="text-lg">{displayEvent.emoji}</span>
          )}
        </div>
      </div>
      
      <h4 className="text-lg font-bold text-red-200 mb-1 truncate">
        {displayEvent.name || displayEvent.event}
      </h4>
      <p className="text-white/70 text-xs line-clamp-2 mb-2">
        {displayEvent.description || displayEvent.celebration}
      </p>
      
      {displayEvent.significance && (
        <p className="text-red-100/80 text-xs italic line-clamp-1">
          💫 {displayEvent.significance}
        </p>
      )}
    </Card>
  );
}
